const { $ } = window;

function isNumericKey(keyCode) {
  if (keyCode === undefined) {
    return false;
  }

  if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
    return true;
  }
  return false;
}

export default (otpGroup) => {
  const $wrap = $(otpGroup);
  const $inputs = $wrap.find('input[data-input-opt]');
  let listening = false;

  function onInput(event) {
    const $input = $(event.target);
    const inputIndex = $inputs.index($input);

    if ($input.val().length.toString() === $input.attr('maxLength')
      && inputIndex < ($inputs.length - 1)
      && isNumericKey(event.keyCode)
    ) {
      $inputs[inputIndex + 1].select();
    }
  }

  $inputs.on('keyup', onInput);
  listening = true;

  return {
    getGroup() {
      return $wrap;
    },
    getInputs() {
      return $inputs;
    },
    reset() {
      $inputs.each((i, el) => {
        $(el).val('');
      });
    },
    stop() {
      if (listening === true) {
        $inputs.off('keyup', onInput);
        listening = false;
      }
    },
    listen() {
      if (listening === false) {
        $inputs.on('keyup', onInput);
        listening = true;
      }
    },
  };
};
